import React from "react";
import { Layout } from "antd";
import ditu from "../../assets/img/logo_shouye_dibu.png";
import weichat from "../../assets/img/img_dibu_guanfangweixin.png";
const { Footer } = Layout;
class Foot extends React.Component {
  render() {
    return (
        <Footer style={{ textAlign: "center" }}>
        <div className="footer_font">
          <div className="fonter_content">
            <div className="left">
              <img src={ditu} className="ditu" />
              <div className="gap"></div>
              <div className="des">
                <span>客服电话：010-62961200 / 010-57013456</span>
                <span>商务合作：kf@neworangegroup.com</span>
                <span>
                  公司地址：北京市海淀区东北旺西路58号院东侧B楼二层2014
                </span>
              </div>
            </div>
            <div className="code">
              <img src={weichat} className="" />
              <div>
                <span>官方公众号</span>
              </div>
            </div>
          </div>
        </div>
        <div className="Copyright">
          <span>
            <span style={{ opacity: 0.5 }}>
              Copyright© 新橙智慧科技发展有限公司 京ICP备2020040301号<span style={{margin:'0 10px'}}>|</span>
            </span>
            <a className="pdfClick" href={require("../../commons/隐私政策.pdf").default} target="_blank">
              隐私政策
            </a>
            <span style={{ opacity: 0.5,margin:'0 10px' }}>|</span>
            <a className="pdfClick" href={require("../../commons/免责声明.pdf").default} target="_blank">
              免责声明
            </a>
          </span>
        </div>
      </Footer>
    );
  }
}

export default Foot;
